
export const getUserApiGet = (data) => {
    return data.data
}



